// ServiceOverview/ServiceOverviewFetcher.js
// Singleton — does exactly 1 thing: raw I/O via PluginStateService.
import pluginStateService from '../../../services/PluginStateService';
import CoreBase from '../../../services/engines/CoreBase';

const _name = 'ServiceOverviewFetcher';

class ServiceOverviewFetcher extends CoreBase {
    _name = _name;

    /**
     * @returns {Promise<object[]|null>} plugin state items, null when the request failed
     */
    fetch = async () => {
        try {
            // agent.get never throws: a failure comes back as null/undefined or a non-2xx response
            const response = await pluginStateService.getPluginStates();
            const ok = response?.status >= 200 && response?.status < 300;
            const items = response?.data?.items;
            if (ok && Array.isArray(items)) return items;

            const reason = response?.status ? `HTTP ${response.status}` : 'no HTTP response (network error, CORS or unknown KrakenD route)';
            this.logError('fetch', `no plugin states — ${reason}`);
            return null;
        } catch (error) {
            this.logError('fetch', error.message);
            return null;
        }
    };
}

const serviceOverviewFetcher = new ServiceOverviewFetcher();
export default serviceOverviewFetcher;
